<h2 mat-dialog-title>Estructura del schema</h2>

<mat-dialog-content class="dialog-content">
  <p class="schema-name">{{ data.schemaName || 'Schema' }}</p>

  @if (schemaColumns.length) {
    <div class="columns-list">
      @for (col of schemaColumns; track col.name; let i = $index) {
        <div class="col-row">
          <div class="col-index">{{ i + 1 }}</div>

          <div class="col-body">
            <div class="col-main">
              <span class="col-label">{{ col.label || col.name }}</span>
              <code class="col-name">{{ col.name }}</code>
              <span class="col-type">{{ col.data_type || 'text' }}</span>
              @if (col.required) {
                <span class="badge badge-req">req</span>
              }
              @if (col.unique) {
                <span class="badge badge-uniq">único</span>
              }
            </div>

            @if (col.description) {
              <p class="col-desc">{{ col.description }}</p>
            }

            @if (constraintChips(col).length) {
              <div class="constraint-chips">
                @for (chip of constraintChips(col); track chip) {
                  <span class="c-chip">{{ chip }}</span>
                }
              </div>
            }

            @if (col.enum_values?.length) {
              <div class="enum-values">
                @for (v of col.enum_values!; track v) {
                  <span class="enum-val">{{ v }}</span>
                }
              </div>
            }

            @if (col.example) {
              <p class="col-example">ej: {{ col.example }}</p>
            }
          </div>
        </div>
      }
    </div>
  } @else {
    <p class="empty-text">Este schema no tiene columnas configuradas.</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
